import { trpc } from '@/shared/api/trpc';

export const useRemoveAccount = () => {
  const utils = trpc.useUtils();
  return trpc.accounts.remove.useMutation({
    onSettled: () => {
      utils.accounts.listAllowlist.invalidate();
      utils.accounts.list.invalidate();
      utils.accounts.listForFilters.invalidate();
    },
  });
};
